<div class="tag-container" rlStopPropagation>
	<div class="justify-content flex-wrap">
		<div class="flex-basis half-margin-bottom " *ngFor="let tag of _tags | sortTags ; let i=index">
			<rl-tag [tag]="tag" (onRemove)="remove($event)" [hideRemove]="editDisabled" [id]="'tag-' + tag.tagCode +'-'+i"></rl-tag>
		</div>
	</div>
</div>
<rl-select-tag *ngIf="!editDisabled || freeTextEnabled" [entityType]="legantoEntity.entityType" [tags]="tagsToAdd" (onSelect)="select($event)" [freeTextEnabled]="freeTextEnabled"  [id]="'tag-select-' + legantoEntity.id"></rl-select-tag>
